import { snakeToCamel } from '../../../utils/object'

import Model from '../models'

import CohortAPI from './api'
import Application from '@/services/applications'
import User from '@/services/users'

export default class Cohort extends Model {
  static api = CohortAPI.create(Cohort)
  static readOnlyFields = ['id', 'organizationName', 'hasCommitments', 'isCompleted']

  constructor({ id = null, name = '', isActive = null, applications = [], evaluators = [], applicants = [] } = {}) {
    super()
    Object.assign(this, {
      id,
      name,
      isActive,
      applications,
      evaluators,
      applicants,
    })
  }

  static create(opts = {}) {
    if (opts.applications) {
      opts.applications = opts.applications.map(Application.create)
    }
    if (opts.evaluators) {
      opts.evaluators = opts.evaluators.map(User.create)
    }
    if (opts.applicants) {
      opts.applicants = opts.applicants.map(User.create)
    }
    return new Cohort(opts)
  }

  static fromAPI(json = {}) {
    const jsonCamel = snakeToCamel(json)
    if (jsonCamel.tags_ref) {
      jsonCamel.tags_ref = jsonCamel.tags_ref.map(Application.fromAPI)
    }
    if (jsonCamel.evaluators) {
      jsonCamel.evaluators = jsonCamel.evaluators.map(User.fromAPI)
    }
    if (jsonCamel.applicants) {
      jsonCamel.applicants = jsonCamel.applicants.map(User.fromAPI)
    }
    return new Cohort(jsonCamel)
  }

  copy() {
    return new Cohort(this)
  }
}
